import React from 'react';
import { Select } from 'antd';
import { t } from '../../../i18n/i18n';
import DeviceIcon from '../../DeviceIcon/DeviceIcon';

const { Option } = Select;

export const TestGroupDevices = ({
  testGroupData,
  handleSelectDevicesOption,
  readOnly = false,
}) => {
  const deviceOptions = [
    { value: 'LAPTOP', label: 'DEVICE_LAPTOP', icon: 'LAPTOP' },
    { value: 'IPAD', label: 'DEVICE_IPAD', icon: 'IPAD' },
    { value: 'MOBILE', label: 'DEVICE_MOBILE', icon: 'MOBILE' },
  ];

  return (
    <div className="w-100">
      <div className="my-2 col-flex">
        <span className="row mx-3 font-weight-bold text-base my-2">
          {t('CREATE_TEST_GROUP_DEVICES_TITLE')}
        </span>
        <span className="row mx-2 font-weight-300 text-s my-1">
          {t('CREATE_TEST_GROUP_DEVICES_DESCRIPTION')}
        </span>
        <Select
          mode="multiple"
          style={{
            width: '100%',
          }}
          className=""
          placeholder={t('CREATE_TEST_GROUP_DEVICES_PLACEHOLDER')}
          onChange={(value) => {
            if (!value || value === '') return handleSelectDevicesOption([]);
            const devices = Array.isArray(value) ? value : String(value).split(',');
            handleSelectDevicesOption(devices);
          }}
          value={testGroupData?.recommendedDevices || []}
          popupClassName=""
          disabled={readOnly}
        >
          {deviceOptions.map((device) => (
            <Option key={device.value} value={device.value}>
              <DeviceIcon countryIso={device.icon} size="sm" className="mr-2" />
              {t(device.label)}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  );
};
